import "./index.scss"
export default function PravicyProtocol() {
    return (
        <div className="main" id="pravicyprotocol">
            <p className="title">
                隐私政策
            </p>
            <div className="date-contrainer">
                <div>
                    更新日期：2024年07月03日
                </div>
                <div>
                    生效日期：2024年07月03日
                </div>
            </div>

            <span className="first-indent"/>本《隐私政策》（以下简称“本政策”或“本隐私政策”）适用于上海百昌科技集团有限公司（以下称“再查查”或“我们”）通过APP、网站、客户端、小程序以及随技术发展出现的新形态向用户（以下或称“您”）提供的各项产品和服务。针对某些特定的产品/服务，我们可能还将制定单独的隐私政策，向您说明这些产品/服务的特殊政策。如相关特定的隐私政策与本政策有不一致之处，适用该特定隐私政策。
            <br />
            <span className="first-indent"/>再查查非常重视保护用户的个人信息及隐私，我们深知个人信息对您的重要性，我们也深知您向再查查提供各种信息是基于对再查查的完全信任，我们将严格按照法律法规要求，采取相应的安全保护措施来保护您的个人信息安全。基于此，我们制定本政策，希望通过本政策向您清晰地介绍在使用我们的产品/服务时，我们会如何收集、使用、共享、存储、保护您的个人信息，以及我们为您提供的访问、更正、删除这些信息的方式。

            <p>
            <span className="first-indent"/> 在使用再查查各项产品和服务前，请您务必仔细阅读并透彻理解本政策，特别应重点阅读我们以黑体加粗或加下划线标识的条款，在确认充分理解并同意后再开始使用再查查服务。一旦您使用或继续使用我们的产品、服务时，即意味着您同意我们按照本政策处理您的相关信息。如您不同意协议中的任何条款，您应立即停止访问再查查。
            </p>
            <br />
            <p>
                本政策将帮助您了解以下内容：
            </p>
            1、我们如何收集和使用您的个人信息
            <br />
            2、我们如何使用 Cookie 和同类技术
            <br />
            3、我们如何共享、转让、公开披露您的个人信息
            <br />
            4、我们如何保护和保存您的个人信息
            <br />
            5、通知和修订
            <br />
            6、如何联系我们
            <br />
            <br />
            <p>
                一、我们如何收集和使用您的个人信息
            </p>

            <span className="first-indent"/>本隐私政策中涉及的个人信息是指以电子或其他方式记录的能够单独或者与其他信息结合识别自然人身份或者反映特定自然人活动情况的各种信息，包括但不限于<span>自然人的基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证）；金融账户信息（包括账号及开户行）；债权信息；</span>企业营业执照、企业名称、统一社会信用代码、对公银行账号及开户行信息；面部特征；网络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（交易和消费记录、房产信息）；个人上网记录（包括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息。
            <p>（一）收集、使用的基本原则</p>
            <span className="first-indent"/>我们会遵循合法、正当、必要的原则，出于向您提供相关产品和服务的目的向您收集和处理您的个人信息，并向您披露。我们尽可能全面、完整、及时地向您披露您的个人信息的收集和使用情况，若您发现我们的披露存在错误或遗漏，请通过本政策所述的联系方式与我们联系。
            <br/>
            <span className="first-indent"/>在您使用我们的产品/服务时，您需要/可能需要授权我们收集和使用的您的个人信息包括如下两种：
            <br/>
            （1）为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；
            <br/>
            （2）为实现向您提供我们产品及/或服务的附加功能，您可选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但不会影响您使用我们的基本功能。
            <p>（二）您须授权我们收集和使用您个人信息的情形</p>
            <span className="first-indent"/>我们的服务包括核心业务功能和附加功能。我们的服务包括一些核心功能，这些功能包含了实现企业综合经营信息及财产线索查询所必须的功能、改进我们的服务所必须的功能及保障交易安全所必须的功能。我们需要收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的服务。
            <p>1、实现我们的基本及附加功能</p>
            （1）为实现向您提供我们及/或服务的基本功能，您须授权我们收集、使用必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的我们及/或服务；
            <br/>
            （2）为实现向您提供我们及/或服务的附加功能，您可选择单独同意或不同意我们收集、使用信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但不会影响您使用我们的基本功能。
            <p>2、改进我们的服务所必需的功能</p>
            <span className="first-indent"/>我们可能会收集您的个人信息、浏览信息进行数据分析以形成用户画像，用来将您可能感兴趣的服务信息展示给您。
            <p>3、保障交易安全所必需的功能</p>
            <span className="first-indent"/>为提高您使用我们的服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的各类信息来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息对于我们系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。具体而言，本我们收集的信息包括但不限于：
            <br/>
            <span className="first-indent"/>（1）设备信息：为便于设备识别、进行数据统计和分析，保障网络访问及服务运营的安全和质量，我们会根据您在访问及/或使用中的具体操作及后台状态下，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、MAC地址及IMEI、IMSI、MEID、IDFA、OAID设备标识符、Android ID、IP、SD卡数据、设备环境、移动应用列表软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站传感器信息）。为了预防恶意程序、保障运营质量及效率，我们会收集正在运行中的进程信息、应用程序的总体运行、应用崩溃情况、总体安装使用情况、性能数据、应用来源。
            <br/>
            <span className="first-indent"/>（2）服务日志信息：当您使用本网站服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间等。
            <span className="first-indent"/>请注意，单独的设备信息、服务日志信息无法识别特定自然人身份。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息进行匿名处理。
            <p>（三）您充分知晓，以下情形中，我们收集、使用个人信息无须征得您的授权同意：</p>
            1、与再查查服务提供者履行法律、法规规定的义务相关的；
            <br/>
            2、与国家安全、国防安全有关的；
            <br/>
            3、与公共安全、公共卫生、重大公共利益有关的；
            <br/>
            4、与犯罪侦查、起诉、审判和判决执行等有关的；
            <br/>
            5、出于维护用户或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
            <br/>
            6、所收集的个人信息是对应的用户自行向社会公众公开的；
            <br/>
            7、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
            <br/>
            8、根据您的要求签订合同，或签订以您为合同当事人（或当事人之一）的合同所必需的；
            <br/>
            9、用于维护所提供的服务的安全稳定运行所必需的，例如发现、处置服务的故障；
            <br/>
            10、为合法的新闻报道所必需的；
            <br/>
            11、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
            <br/>
            12、法律、法规或监管政策规定的其他情形。
            <p>（四）我们从第三方获得您个人信息的情形</p>
            1、如果您通过第三方访问再查查或购买再查查服务，我们可能从第三方获取您授权共享的账户信息（头像、昵称）、联系信息（姓名、电话）、交易信息或其他信息，并在您同意本隐私政策后将您的第三方账户与您的再查查我们账户绑定。
            <br/>
            2、我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。
            <p>（五）使用您个人信息的规则</p>
            1、我们会根据本隐私政策的约定并为实现我们的服务功能对所收集的个人信息进行使用。如果我们将您的个人信息用于本政策未载明的其它用途，我们将以合理的方式向您告知，并在使用前再次征得您的同意。
            <br/>
            2、在收集您的个人信息后，我们将根据实际情况通过技术手段对数据进行去标识化处理，以保护您的信息安全。去标识化处理的信息在不借助额外信息的情况下将无法识别个人信息主体。请您了解并同意，在此情况下我们有权使用及展示已经去标识化的信息，并在不透露您个人信息的前提下，我们权对用户数据库进行分析并进行商业化利用。
            <br/>
            3、请您注意，您在使用我们的服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。
            <br/>
            4、我们会对我们的服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
            <p>二、我们如何使用 Cookie 和同类技术</p>
            1、Cookie是指从网络服务器发送到您的浏览器，并储存到电脑硬盘上的少量数据，通常包括一些特殊标识符、站点名称以及一些号码和字符，是用来记录您的使用者ID。
            <br/>
            2、为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies 是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的资产偏好或您收藏的资产等数据进而为您提供竞拍的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。
            <br/>
            3、我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。
            <p>三、我们如何共享、转让、公开披露您的个人信息</p>
            <p>（一）共享</p>
            1、我们不会与上海百昌科技集团有限公司以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：
            <br/>
            （1）事先获得您明确的同意或授权；
            <br/>
            （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
            <br/>
            （3）在法律法规允许的范围内，为维护我们、上海百昌科技集团有限公司的关联方或合作伙伴、您或其他我们用户或社会公众利益、财产或安全免遭损害而有必要提供；
            <br/>
            （4） 只有共享您的信息，才能实现我们的服务功能或提供您需要的服务；
            <br/>
            （5）应您需求为您处理您与他人的纠纷或争议；
            <br/>
            （6）依据与您签署的相关协议（包括在线签署的电子协议以及相应的我们规则）或其他的法律文件约定而提供；
            <br/>
            （7）基于学术研究而使用；
            <br/>
            （8）基于符合法律法规的社会公共利益而使用。
            <br/>
            2、我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。
            <br/>
            3、我们可能会向合作伙伴等第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们的合作伙伴包括以下类型：
            <br/>
            （1）技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。
            <br/>
            4、对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。
            <br/>
            5、为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护我们、您或其他我们客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过,这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。
            <p>（二）转让</p>
            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
            <br/>
            1、事先获得您明确的同意或授权；
            <br/>
            2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
            <br/>
            3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的我们规则）或其他的法律文件约定所提供；
            <br/>
            4、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。
            <p>（三）公开披露</p>
            我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会向不特定多数对象公开披露您的个人信息：
            <br/>
            1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；
            <br/>
            2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。
            <p>四、我们如何保护和保存您的个人信息</p>
            <p>（一）我们保护您个人信息的技术与措施</p>
            我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
            <br/>
            1、数据安全技术措施
            <br/>
            我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。
            <br/>
            2、我们为保护个人信息采取的其他安全措施
            <br/>
            我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。
            <br/>
            我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。
            <br/>
            3、我们仅允许有必要知晓这些信息的我们及我们关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。
            <br/>
            4、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
            <br/>
            5、如果您对我们的个人信息保护有任何疑问，可通过本政策最下方【如何联系我们】约定的联系方式联系我们。如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本政策最下方约定的联系方式联络我们，以便我们采取相应措施。
            <p>（二）您个人信息的保存</p>
            1、您的个人信息将全被存储于中华人民共和国境内。如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，我们会单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。
            <br/>
            2、除非法律法规另有规定，您的个人信息我们将保存至您账号注销之日后的一个月。
            <br/>
            在以下情形中，您可以向我们提出删除个人信息的请求：
            <br/>
            （1）如果我们处理个人信息的行为违反法律法规；
            <br/>
            （2）如果我们收集、使用您的个人信息，却未征得您的同意；
            <br/>
            （3）如果我们处理个人信息的行为违反了与您的约定；
            <br/>
            （4）如果您注销了再查查账户；
            <br/>
            （5）如果我们终止服务及运营。
            <br/>
            若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
            <p>3、改变您授权同意的范围或撤回您的授权</p>
            您可以通过删除信息、关闭设备功能、在再查查产品中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。
            请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
            <p>五、通知和修订</p>
            （一）我们的个人信息处理规则可能会适时发生变更。未经您明确同意，我们不会限制您按照本处理规则所应享有的权利。我们会在专门页面上发布对本政策所做的任何变更。
            <br/>
            （二）对于重大变更，我们还会提供更为显著的通知。本政策所指的重大变更包括但不限于：
            <br/>
            1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
            <br/>
            2.我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；
            <br/>
            3.个人信息提供、转移或公开的主要对象发生变化；
            <br/>
            4.您参与个人信息处理方面的权利及其行使方式发生重大变化；
            <br/>
            5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；
            <br/>
            6.个人信息安全影响评估报告表明存在高风险。
            <p>六、如何联系我们</p>
            1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请拨打我们的客服电话4000150005与我们联系。
            <br/>
            2、一般情况下，我们将在十五个工作日内回复。
        </div>
    )
}